import moment from 'moment';
import React, { Component } from "react";
import { request } from '../utils/axios';


class SystemLog extends Component {
  constructor(props) {
    super(props);
    this.state = { history: undefined };
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true });
    return request({
      method: "get",
      url: `/reference/systemlog`
    }).then(data => {
      this.setState({ history: data, loadingInProgress: false  })
    });
  }

  render() {
    if (!this.state.history) return null
    return (
      <div>
        <h3 className="first-title">Admin - SystemLog</h3>
        <div className="row">
          <div className="col-sm-12">

          <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">At</th>
                  <th scope="col" style={{width: '100%'}}>Description</th>
                  <th scope="col">Params</th>
                </tr>
              </thead>
              <tbody>
                {this.state.history.map((historyLine) => <>
                  <tr>
                    <td>{historyLine.id}</td>
                    <td>{moment(historyLine.at).format("dddd Do MMM, h:mma")}</td>
                    <td>{historyLine.description}</td>
                    <td width="100%">{
                      historyLine.params &&
                        Object.keys(historyLine.params).forEach(key => {
                          return <div>{key}: historyLine.params[key]</div>
                        })

                    }</td>
                  </tr>
                </>)}
              </tbody>
            </table>

          </div>
        </div>
      </div>
    );
  }
}
export default SystemLog;
